import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.594.642a2.19 2.19 0 0 1 3.1 0l1.664 1.668a2.19 2.19 0 0 1 0 3.1L7.129 17.652a3.8 3.8 0 0 1-1.6.947L.8 19.988a.7.7 0 0 1-.619-.156.62.62 0 0 1-.158-.618l1.391-4.735a3.8 3.8 0 0 1 .947-1.6Zm2.213.886a.94.94 0 0 0-1.33 0l-2.142 2.144 3 2.963 2.143-2.109a.94.94 0 0 0 0-1.329ZM4.286 15.726l2.495.5 8.631-8.673-2.96-3-8.665 8.676Zm-1.529-1.26a2.5 2.5 0 0 0-.14.364L1.55 18.466 5.178 17.4a3 3 0 0 0 .368-.141l-1.914-.383a.63.63 0 0 1-.491-.493Z"
    }, null, -1)
  ])))
}
export default { render: render }